import React, { useEffect, useState } from "react";
import Linguaservice from "./services/lingua/Linguaservice";
import Linguaauservice from "./services/lingua/Linguaauservice";
import Pacchettoservice from "./services/lingua/Pacchettoservice";
import "../node_modules/flag-icons/css/flag-icons.min.css";
import { useLiveQuery } from "dexie-react-hooks";
import db from "./db";
import Storage from './components/utils/Storage';
import Genimposervice from "./services/setup/Genimposervice";


function LangBar(props) {

    const [hidden, setHidden] = useState(undefined);

    useEffect(() => {
        Genimposervice.multilingua().then(response => setHidden(response.data.multilingua !== '1')); /// viene stringa
    }, []);

    const [data, setData] = useState([]);
    const [pacchettiDisponibili, setPacchettiDisponibili] = useState(undefined);

    useEffect(() => {
        Linguaservice.search({ stato1: 1, expand: 'pacchetti' }).then(response => setData(response.data))
    }, []);
    useEffect(() => {
        Pacchettoservice.search({ servizio: 'C' }).then(response => setPacchettiDisponibili(response.data))
    }, []);

    const langs = useLiveQuery(() => db.lingue.toArray());
    const pacchetti = useLiveQuery(() => db.pacchetti.toArray());

    if (hidden === undefined || data.length === 0 || langs === undefined || pacchetti === undefined || pacchettiDisponibili === undefined) { //0-elements in langs prosegue
        return null;
    }

    return (
        <LangBar0
            hidden={hidden}
            {...props}
            data={data}
            pacchetti={pacchetti}
            pacchettiDisponibili={pacchettiDisponibili}
            langMemorizzata={langs.length === 0 ? null : langs[0]}
        />
    );
}

function LangBar0({ hidden, hiddenable, data, langMemorizzata, pacchetti, pacchettiDisponibili, saveUserLang }) {

    const [firstRun, setFirstRun] = useState(true);

    const individuaLang = (lang0) => {
        let l = lang0;
        const codici = data.map(item => item.codice);
        const findPredUtente = (acc, curr) => (!acc && curr.sigla === navigator.language) ? curr : acc;
        const findPredGen = (acc, curr) => (!acc && curr.predefinito) ? curr : acc;
        //1. lang esiste ma non è valida la tolgo
        if (l && !codici.includes(l.codice)) {
            l = null;
        }
        //2. lang nulla : predefinito
        return l || data.reduce(findPredUtente, null) || data.reduce(findPredGen, null);

    }

    const langAttuale = individuaLang(langMemorizzata);

    const memorizzo = async (lingua) => {
        //db.transaction('rw', [db.lingue, db.pacchetti, db.traduzioni,], async () => {
        const dataLettura = new Date();
        const codice = lingua.codice;
        const field = 'lingua' + codice.charAt(0).toUpperCase() + codice.slice(1);
        const nomi = (pacchetti || []).map(item => item.nome);
        await db.lingue.clear();
        await db.pacchetti.clear();
        await db.traduzioni.clear();
        const r = await Pacchettoservice.search({ nomi, expand: 'traduzioni', });
        const pacchettiNuovi = r.data;
        console.log('cambiolingua', nomi);
        for (let i in pacchettiNuovi) {
            const { traduzioni, ...p } = pacchettiNuovi[i];
            await db.pacchetti.add({ ...p, dataLettura });
            //memorizza traduzioni
            for (let i in traduzioni) {
                const item = traduzioni[i];
                const valore = item[field];
                await db.traduzioni.add({ pacchettoId: item.pacchettoId, chiave: item.chiave, valore });
            }
        }
        await db.lingue.add(lingua);
        //})

    }


    const rimuovoPacchettiOutOfVersion = async (pacchettiMap, lingua) => {
        const nomi = [];
        //console.log(pacchettiMap, pacchetti);
        if (pacchetti) {
            pacchetti.forEach(pacchetto => {
                const versioneBuona = pacchettiMap[pacchetto.id]?.versione;
                if (versioneBuona && versioneBuona > pacchetto.versione) {
                    db.pacchetti.update(pacchetto.id, { versione: versioneBuona });
                    nomi.push(pacchetto.nome);
                }
            });
        }
        const dataLettura = new Date();
        const codice = lingua.codice;
        const field = 'lingua' + codice.charAt(0).toUpperCase() + codice.slice(1);
        if (nomi.length !== 0) {
            //console.log('aggiornamento versioni ', nomi);
            // li riprendo
            const r = await Pacchettoservice.search({ nomi, servizio: 'C', expand: 'traduzioni', });
            const pacchettiNuovi = r.data;
            for (let i in pacchettiNuovi) {
                const { traduzioni, ...p } = pacchettiNuovi[i];
                await db.pacchetti.update(p.id, { dataLettura });
                //aggiorna traduzioni
                for (let i in traduzioni) {
                    const item = traduzioni[i];
                    const valore = item[field];
                    const exists = await db.traduzioni.where({ pacchettoId: item.pacchettoId, chiave: item.chiave }).first()
                    if (exists) {
                        await db.traduzioni.update(exists.id, { valore });
                    } else {
                        await db.traduzioni.add({ pacchettoId: item.pacchettoId, chiave: item.chiave, valore });
                    }
                }
            }
        }
    }
    const linguaId = Storage.getItem('linguaId');
    const limitazioneLingua = Storage.getItem('limitazioneLingua') === '1';
    useEffect(() => {

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [linguaId, data]);

    useEffect(() => {
        console.log({ langAttuale, langMemorizzata, pacchettiDisponibili, firstRun, linguaId })
        setFirstRun(false);
        if (linguaId) {
            //se ho linguaId è una request (dal login) di impostazione
            const lingua = data.reduce((acc, curr) => (!acc && curr.id === parseInt(linguaId)) ? curr : acc, null);
            Storage.removeItem('linguaId');
            //console.log('passo a lingua user ' + linguaId)
            if (lingua) {
                memorizzo(lingua);
            }
        } else if (firstRun && langAttuale && langAttuale.codice !== langMemorizzata?.codice) {
            //memorizzo lingua di default (1o giro)
            console.log('save default');
            memorizzo(langAttuale);
        } else if (firstRun) {
            const pacchettiMap = {};
            pacchettiDisponibili.forEach(item => {
                pacchettiMap[item.id] = item;
            });
            if (langMemorizzata) {
                console.log('controllo versione')
                rimuovoPacchettiOutOfVersion(pacchettiMap, langMemorizzata);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [langAttuale, langMemorizzata, pacchettiDisponibili, firstRun, linguaId])

    const handleChange = item => {
        memorizzo(item);
        if (saveUserLang) {
            Linguaauservice.imposta({ linguaId: item.id });
        }

    }
    const isSuperUser = Storage.getItem('user_level') === 'S';

    if ((hidden && !hiddenable) || ((isSuperUser || limitazioneLingua) && hiddenable)) {
        return null;
    }

    return (
        <div className="d-flex">
            {data.map(item => (
                <div
                    key={item.id}
                    className={'noprintable p-3' + (item.codice === langAttuale.codice ? '' : ' cursor-pointer')}
                    onClick={item.codice === langAttuale.codice ? undefined : () => handleChange(item)}
                >
                    <div className="d-flex">
                        <div style={{ width: '2rem' }} className={' rounded fi fi-' + item.bandiera + ' fis'}> </div>
                        <div className={item.codice === langAttuale.codice ? 'font-weight-bold' : ''}>{item.nome}</div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default LangBar;